const actions = {
  SEARCH_EXPORT_TASKS: 'SEARCH_EXPORT_TASKS',
  SEARCH_EXPORT_TASKS_ENDED: 'SEARCH_EXPORT_TASKS_ENDED',
  SEARCH_EXPIRING_SOON_MEMBER_POINT_REPORTS: 'SEARCH_EXPIRING_SOON_MEMBER_POINT_REPORTS',
  SEARCH_EXPIRING_SOON_MEMBER_POINT_REPORTS_ENDED:
    'SEARCH_EXPIRING_SOON_MEMBER_POINT_REPORTS_ENDED',

  DOWNLOAD_EXPORTED_FILES: 'DOWNLOAD_EXPORTED_FILES',
  DOWNLOAD_EXPORTED_FILES_ENDED: 'DOWNLOAD_EXPORTED_FILES_ENDED',

  UPDATE_EXPORT_TASKS: 'UPDATE_EXPORT_TASKS',
  UPDATE_EXPORT_TASKS_ENDED: 'UPDATE_EXPORT_TASKS_ENDED',

  SEARCH_POINT_EXPORT_TASKS: 'SEARCH_POINT_EXPORT_TASKS',
  SEARCH_POINT_EXPORT_TASKS_ENDED: 'SEARCH_POINT_EXPORT_TASKS_ENDED',

  UPDATE_EXPORT_EXCEL_TASKS: 'UPDATE_EXPORT_EXCEL_TASKS',
  UPDATE_EXPORT_EXCEL_TASKS_ENDED: 'UPDATE_EXPORT_EXCEL_TASKS_ENDED',

  CREATE_POINT_EXPORT_TASK: 'CREATE_POINT_EXPORT_TASK',
  CREATE_POINT_EXPORT_TASK_ENDED: 'CREATE_POINT_EXPORT_TASK_ENDED',
};
export default actions;
